import { useTranslation } from 'react-i18next';

import { DataPanel, DataPanelAutoWrapInlineItem, DebugView } from '@/ui';
import type { Caller } from '@/signalr';
import { CallerFullNamePanelItem } from './CallerFullNamePanelItem';
import { PhoneNumberPanelItems } from './PhoneNumberPanelItems';

export type CallerSectionProps = {
  incidentId: string;
  caller: Caller;
  incidentIsReadOnly: boolean;
};

export function CallerSection({ incidentId, caller, incidentIsReadOnly }: CallerSectionProps) {
  const { t } = useTranslation();

  return (
    <DataPanel header={t('Incident_InfoPanel_Caller_PanelHeader')}>
      <CallerFullNamePanelItem
        incidentId={incidentId}
        callerFullName={caller.fullname}
        editable={!incidentIsReadOnly}
      />

      <PhoneNumberPanelItems
        incidentId={incidentId}
        phoneNumbers={caller.phoneNumbers}
        editable={!incidentIsReadOnly}
      />

      <DataPanelAutoWrapInlineItem
        title={t('Incident_InfoPanel_InsuranceNumber')}
        value={caller.insuranceNumber ?? undefined}
        allowCopyToClipboard
        showEmptyPlaceholder
      />

      <DebugView>
        <DataPanelAutoWrapInlineItem
          title={t('Incident_InfoPanel_Email')}
          value={caller.email ?? undefined}
          linkUrl={caller.email == null ? undefined : `mailto:${caller.email}`}
          showEmptyPlaceholder
        />
      </DebugView>
    </DataPanel>
  );
}
